import { render, staticRenderFns } from "./CardRankingModel.vue?vue&type=template&id=ca92ccb8"
import script from "./CardRankingModel.vue?vue&type=script&lang=js"
export * from "./CardRankingModel.vue?vue&type=script&lang=js"
import style0 from "./CardRankingModel.vue?vue&type=style&index=0&id=ca92ccb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports